import { UserService } from '../../services/user.service';
import { CommonConstant, InfluencerTab, InfluencerTabName } from '../../app.constants';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { PlaceholderVisibilityService } from '../../services/placeholder-visibility/placeholder-visibility.service';
import { InfluencerService } from '../../services/influencer/influencer.service';
import { AchooPopupComponent } from '../../core/achoo-popup/achoo-popup.component';
import { ModalService } from '../../services/modal/modal.service';
import { PdfViewerService } from '../../main/pdf-viewer/pdf-viewer.service';
var InfluencerDetailsComponent = /** @class */ (function () {
    function InfluencerDetailsComponent(userService, placeholderService, influencerService, location, modalService, pdfViewerService, router, route) {
        this.userService = userService;
        this.placeholderService = placeholderService;
        this.influencerService = influencerService;
        this.location = location;
        this.modalService = modalService;
        this.pdfViewerService = pdfViewerService;
        this.router = router;
        this.route = route;
    }
    InfluencerDetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.currentInfluencer = this.userService.getInfluencerInfo();
        this.route.data.subscribe(function (res) {
            _this.activeTabIndex = res.order;
        });
        this.initializeComponent();
    };
    InfluencerDetailsComponent.prototype.ngOnDestroy = function () {
        if (this.exportPdfSubcription) {
            this.exportPdfSubcription.unsubscribe();
        }
        // clear active channel
        this.influencerService.updateActiveChannel(null);
    };
    InfluencerDetailsComponent.prototype.onChangeActiveChannel = function (evt) {
        if (evt) {
            this.insightChannelParam = evt.channel;
            this.updateUrl(evt.activeTab, evt.channelFollower);
        }
    };
    InfluencerDetailsComponent.prototype.changeDemographicSource = function (channelId) {
        this.demographicChannelParam = channelId;
        this.updateUrl(InfluencerTabName.DEMOGRAPHIC);
    };
    InfluencerDetailsComponent.prototype.initializeComponent = function () {
        var _this = this;
        this.placeholderService.hide(CommonConstant.INFLUENCER_BASIC_INFORMATION_HOLDER);
        this.influencerService.getInfluencer(this.currentInfluencer.id).subscribe(function (data) {
            _this.placeholderService.hide(CommonConstant.INFLUENCER_BASIC_INFORMATION_HOLDER);
            _this.influencerDetail = data;
            _this.route.queryParams.subscribe(function (params) {
                var selectedChannel = _this.influencerDetail.channels.find(function (c) { return c.id === Number(params.insightChannel); });
                if (selectedChannel) {
                    _this.influencerService.updateActiveChannel(selectedChannel);
                }
            });
        });
    };
    Object.defineProperty(InfluencerDetailsComponent.prototype, "currentInfluencerId", {
        get: function () {
            return this.currentInfluencer ? this.currentInfluencer.id : null;
        },
        enumerable: true,
        configurable: true
    });
    InfluencerDetailsComponent.prototype.showInsight = function () {
        this.activeTabIndex = InfluencerTab.INSIGHT;
        this.updateUrl(InfluencerTabName.INSIGHT);
    };
    InfluencerDetailsComponent.prototype.showDemographics = function () {
        this.activeTabIndex = InfluencerTab.DEMOGRAPHIC;
        this.updateUrl(InfluencerTabName.DEMOGRAPHIC);
    };
    InfluencerDetailsComponent.prototype.showOverview = function () {
        this.activeTabIndex = InfluencerTab.OVERVIEW;
        this.updateUrl(InfluencerTabName.OVERVIEW);
    };
    InfluencerDetailsComponent.prototype.downloadPDF = function () {
        // cancel previous request
        if (this.exportPdfSubcription) {
            this.exportPdfSubcription.unsubscribe();
        }
        this.modalService.open(this.alertPdfDownloadPending, null, true, CommonConstant.PDF_EXPORT_NOTIFICATION_SHOWING_TIME);
        this.exportPdfSubcription = this.pdfViewerService.generateInfluencerDetailPdf(this.currentInfluencer.id, this.demographicChannelParam, this.userService.getCompanyId(), this.channelFollowerParam, this.insightChannelParam).subscribe();
    };
    InfluencerDetailsComponent.prototype.closePopup = function () {
        this.modalService.close();
    };
    InfluencerDetailsComponent.prototype.updateUrl = function (activeTab, channelFollowerIds) {
        var params = {};
        if (this.insightChannelParam) {
            params = Object.assign({}, params, {
                insightChannel: this.insightChannelParam
            });
        }
        if (this.demographicChannelParam) {
            params = Object.assign({}, params, {
                demographicChannel: this.demographicChannelParam
            });
        }
        if (channelFollowerIds) {
            params = Object.assign({}, params, { channelFollower: channelFollowerIds });
        }
        this.channelFollowerParam = channelFollowerIds;
        var url = this.router.createUrlTree(['dashboard/details', activeTab], {
            queryParams: params
        }).toString();
        this.location.go(url);
    };
    Object.defineProperty(InfluencerDetailsComponent.prototype, "isActiveInsightTab", {
        get: function () {
            return this.influencerDetail && this.activeTabIndex === InfluencerTab.INSIGHT;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerDetailsComponent.prototype, "isActiveDemographicTab", {
        get: function () {
            return this.influencerDetail && this.activeTabIndex === InfluencerTab.DEMOGRAPHIC;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerDetailsComponent.prototype, "isActiveOverviewTab", {
        get: function () {
            return this.influencerDetail && this.activeTabIndex === InfluencerTab.OVERVIEW;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerDetailsComponent.prototype, "isActiveActvityTab", {
        get: function () {
            return this.influencerDetail && this.activeTabIndex === InfluencerTab.OVERVIEW;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerDetailsComponent.prototype, "influencerDetailsData", {
        get: function () {
            return this.influencerDetail;
        },
        enumerable: true,
        configurable: true
    });
    return InfluencerDetailsComponent;
}());
export { InfluencerDetailsComponent };



// WEBPACK FOOTER //
// ./src/app/influencer-platform/influencer-details/influencer-details.component.ts.pre-build-optimizer.js